export class RegistrationLoginModal
    {
        constructor(    public closestatus: boolean,            // if Button=Confirm was selected=true
                        public registerOrLogin: number,         // Registration OR Login
                        public eventid: string,                 // EventId
                        public eventname: string,               // Event Name
                        public selpassword: string,             // password entered
                        public selemail: string,                // email entered
                        public loginstatus: boolean,            // Success of Login = true
                        public errorcode: number,               // Error Code  
                        public newpassword: string,             // password reset
                        public stripestatus: boolean,           // StripeStatus
                        public stripetoken: string,             // Stripetoken
                        public spare: number                    // Spare -> Will be use to determine whether is admin=0 or event=-1
                    ) 
            { 

                
            }
    }